import { render } from "./RewardHistory.vue?vue&type=template&id=0169f94e&scoped=true"
import script from "./RewardHistory.vue?vue&type=script&lang=js"
export * from "./RewardHistory.vue?vue&type=script&lang=js"

import "./RewardHistory.vue?vue&type=style&index=0&id=0169f94e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0169f94e"]])

export default __exports__